import { Card } from "@mui/material";
import { IoIosInformationCircleOutline } from "react-icons/io";

export default function InfoAlert({ message }) {
  return (
    <Card
      variant="outlined"
      style={{
        fontSize: "13px",
        color: "#616970",
        padding: "10px",
        display: "flex",
        border: "none",
        alignItems: "center",
        textAlign: "justify",
        lineHeight: "1",
        border: "1px solid #e5f3ff",
        borderRadius: 0,
        backgroundColor: "#f0f8ff",
        width: "100%",
      }}
    >
      <div
        style={{
          fontSize: "20px",
          paddingRight: 10,
          color: "#218aff",
          display: "flex",
          alignItems: "center",
        }}
      >
        <IoIosInformationCircleOutline />
      </div>
      {message}
    </Card>
  );
}
